import React, { FC, useState } from 'react';
import { useParams } from 'react-router';

import { EvErrorCard, useSkipLinks } from '@evinced-private/ui-common';

import { WfaDetailsBlock } from 'src/apps/wfa/components/WfaDetailsBlock';
import { useSetWfaBreadcrumbs } from 'src/apps/wfa/hooks/useSetWfaBreadcrumbs';
import { useShowNewIssueDetailsModal } from 'src/common/hooks/useShowNewIssueDetailsModal';
import { useWhiteBackground } from 'src/common/hooks/useWhiteBackground';
import { DASHBOARD_ERROR_MSG } from 'src/common/pages/dashboards-container/errorMessages';

import { useWfaSessionNameQuery } from '../../hooks/useWfaSessionNameQuery';

import './WfaSingleIssuePage.scss';

export const WfaSingleIssuePage: FC = () => {
	const { sessionId, issueId } = useParams<{ sessionId: string; issueId: string }>();
	const [error, setError] = useState(null);
	const isNewModal = useShowNewIssueDetailsModal();

	useSkipLinks(true);
	useWhiteBackground();
	const sessionNameQuery = useWfaSessionNameQuery(sessionId);
	useSetWfaBreadcrumbs(sessionId, sessionNameQuery?.data ?? '');

	return (
		// The new full page is edge-to-edge (own sticky header); only the old one and the error card use the padded card
		<div className={isNewModal && !error ? undefined : 'issue-details-page'}>
			{error ? (
				<EvErrorCard title="Error" contactUsMessage={DASHBOARD_ERROR_MSG} />
			) : (
				<WfaDetailsBlock
					runId={sessionId}
					issueId={issueId}
					isFullPageMode
					isNewModal={isNewModal}
					setError={setError}
				/>
			)}
		</div>
	);
};
